import {CSSProperties} from '../../../styleSheet';
import {BaseShadowProps} from '../types';

export const buildShadowStyle = ({
  raised,
}: BaseShadowProps = {}): CSSProperties => {
  return {
    ...(raised ? {boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)'} : {}),
  };
};
